const ArrayHelper = {
  dynamicSort(property) {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
      const result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  },
  sortByKey: function (array, key, asc = true, DDKey) {
    // CHANGE REQUEST : ADD ORDERING PARAMETER. DEFAULT ASC.
    //                : function(array: Array<any>, key: any, asc: boolean = true, DDKey: string = '')
    return array.sort(function (a, b) {
      let x = DDKey ? a[DDKey][key] : a[key];
      let y = DDKey ? b[DDKey][key] : b[key];
      return x < y ? (asc ? -1 : 1) : x > y ? (asc ? 1 : -1) : 0;
    });
  },
  groupByKey(array, key) {
    return array.reduce((rv, x) => {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  },

  uniqueBykey(arr, key) {
    let group = [];
    for (const data of arr) {
      const find = group.find((x) => x[key] == data[key]);
      if (find) {
        let list = [];
      } else {
        group.push(data);
      }
    }
    return group;
  },
  wildCardSearch(obj, keyword) {
    for (const [key, value] of Object.entries(obj)) {
      if (JSON.stringify(value).includes(keyword)) return true;
    }
    return false;
  },
  staffSearch(obj, keyword) {
    obj.chiName = obj["ChiLastName"] + obj["ChiName"];
    obj.engName = obj["EngName"] + ' ' + obj["EngLastName"];
    for (const [key, value] of Object.entries(obj)) {
      if (JSON.stringify(value).toLowerCase().includes(keyword)) return true;
    }
    return false;
  },
};

export default ArrayHelper;



// WEBPACK FOOTER //
// ./src/common/helper/ArrayHelper.js